import React from "react";
import { CircularProgress as CircularProgress$1 } from "@mui/material";
import { makeStyles } from "tss-react/mui";
const useClasses = makeStyles()(() => ({
  loadingProgress: {
    position: "absolute",
    top: "50%",
    left: "50%"
  }
}));
function CircularProgress({ position }) {
  const { classes, cx } = useClasses();
  return /* @__PURE__ */ React.createElement(CircularProgress$1, { className: cx({ [classes.loadingProgress]: position === "center" }) });
}
export {
  CircularProgress
};
//# sourceMappingURL=CircularProgress.js.map
